import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import ImageContainer from '../../components/ui/ImageContainer';
import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { IHeroVideos } from '../../types';
import { HeroVideos, HeroVideosBn } from '../../utils';
import './styles.css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

function Home() {
  const locale = getData(LANGUAGE);
  const data = locale === 'en' ? HeroVideos : HeroVideosBn;
  const [sliderRef, setSliderRef] = useState<Slider | null>(null);
  const [firstImageLoaded, setFirstImageLoaded] = useState(false);

  const next = () => {
    sliderRef?.slickNext();
  };

  const previous = () => {
    sliderRef?.slickPrev();
  };

  useEffect(() => {
    const img = new Image();
    img.src = data[0].video;
    img.onload = () => {
      setFirstImageLoaded(true);
    };
  }, [data]);

  useEffect(() => {
    if (firstImageLoaded && sliderRef) {
      sliderRef.slickPlay();
    }
  }, [firstImageLoaded, sliderRef]);

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: false,
    arrows: false, // Disable default arrows since we're using custom ones
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        }
      }
    ],
    dotsClass: 'button__bar',
  };

  return (
    <div className="relative w-full">
      <Slider
        ref={(slider) => setSliderRef(slider)}
        {...settings}
        className="w-full"
      >
        {data.map((item: IHeroVideos, index: number) => (
          <div key={index} className="relative">
            <ImageContainer
              src={item.video}
              alt={`Slide ${index + 1}`}
              className="h-auto w-full" // Responsive height
              onFirstImageLoad={index === 0 ? () => setFirstImageLoaded(true) : undefined}
            />
          </div>
        ))}
      </Slider>

      {/* Custom Navigation Buttons - Hidden on mobile using Tailwind */}
      <button
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-transparent bg-opacity-90 hover:bg-gray-800 text-gray-500 p-2 rounded-full transition-all duration-200 z-10 hidden md:block"
        onClick={previous}
      >
        <FaArrowLeft size={24} />
      </button>
      <button
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-transparent hover:bg-gray-800 text-gray-500 p-2 rounded-full transition-all duration-200 z-10 hidden md:block"
        onClick={next}
      >
        <FaArrowRight size={24} />
      </button>
    </div>
  );
}

export default Home;